import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import theme from './theme';

import MobileBoard from './MobileBoard'

const GlobalStyle = createGlobalStyle`  
    html, body, h1, h2, h3, h4, p, div, ul, ol, li, img {
        padding: 0;
        border: 0;
        margin: 0;
        font: inherit;
        font-size: 16px;
        font-family: 'Lato';        
        line-height: 1.4;
        border: none;
        outline: none;
    }
`

// 여기에서 Desktop / Mobile 분기할 예정

export default function App() {   
    return (            
        <ThemeProvider theme={theme}>
            <React.Fragment>              
                <GlobalStyle/>      
                <MobileBoard/>
            </React.Fragment>            
        </ThemeProvider>
    )    
}



